import React from 'react';
import PropTypes from 'prop-types';


class Inject extends React.Component {
    static propTypes = {
        attributes: PropTypes.object, // eslint-disable-line react/forbid-prop-types
        onCreate: PropTypes.func,
        onError: PropTypes.func.isRequired,
        onLoad: PropTypes.func.isRequired,
        url: PropTypes.string.isRequired,
    };

    static defaultProps = {
        attributes: {},
        onCreate: () => {},
        onError: () => {},
        onLoad: () => {},
    }

    static scriptObservers = {};
    static loadedScripts = {};
    static erroredScripts = {};
    static idCount = 0;

    scriptLoaderId = `id${this.constructor.idCount++}`

    componentDidMount() {
        const { onError, onLoad, url } = this.props;

        if (this.constructor.loadedScripts[url]) {
            onLoad();
            return;
        }

        if (this.constructor.erroredScripts[url]) {
            onError();
            return;
        }

        if (this.constructor.scriptObservers[url]) {
            this.constructor.scriptObservers[url][this.scriptLoaderId] = this.props;
            return;
        }

        this.constructor.scriptObservers[url] = { [this.scriptLoaderId]: this.props };

        this.createScript();
    }

    componentWillUnmount() {
        const { url } = this.props;
        const observers = this.constructor.scriptObservers[url];

        if (observers) {
            delete observers[this.scriptLoaderId];
        }
    }

    createScript() {
        const { onCreate, url, attributes } = this.props;
        const script = document.createElement('script');

        onCreate();

        // add 'data-' or non standard attributes to the script tag
        if (attributes) {
            Object.keys(attributes).forEach(prop => script.setAttribute(prop, attributes[prop]));
        }

        script.src = url;

        // default async to true if not set with custom attributes
        if (!script.hasAttribute('async')) {
            script.async = 1;
        }

        const callObserverFuncAndRemoveObserver = (shouldRemoveObserver) => {
            const observers = this.constructor.scriptObservers[url];
            Object.keys(observers).forEach((key) => {
                if (shouldRemoveObserver(observers[key])) {
                    delete this.constructor.scriptObservers[url][this.scriptLoaderId];
                }
            });
        };
        script.onload = data => {
            console.log('data', data)
            this.constructor.loadedScripts[url] = true;
            callObserverFuncAndRemoveObserver((observer) => {
                observer.onLoad();
                return true;
            });
        };
        script.onerror = data => {
            console.log('data', data)
            this.constructor.erroredScripts[url] = true;
            callObserverFuncAndRemoveObserver((observer) => {
                observer.onError();
                return true;
            });
        };
        document.body.appendChild(script);
    }

    render() {
        return React.createElement('script', {...tagProps, ref: (tag) => this.domRef = tag });
    }
}

export default Inject;
